import {
	ConfluenceBlogpostAri,
	ConfluencePageAri,
	ConfluenceWhiteboardAri,
} from '@atlassian/ari/confluence';

export const getConfluenceContentAri = (siteId: string, contentId: string, contentType: string) => {
	let ari: ConfluencePageAri | ConfluenceBlogpostAri | ConfluenceWhiteboardAri | undefined =
		undefined;
	try {
		switch (contentType) {
			case 'page':
				ari = ConfluencePageAri.create({
					siteId,
					pageId: contentId,
				});
				break;
			case 'blogpost':
				ari = ConfluenceBlogpostAri.create({
					siteId,
					blogpostId: contentId,
				});
				break;
			case 'whiteboard':
				ari = ConfluenceWhiteboardAri.create({
					siteId,
					whiteboardId: contentId,
				});
				break;
		}
	} catch {
		return null;
	}
	return ari?.toString();
};
